// 添加 userInfo 到组件
export const MY_WEBSOCKET = 'MY_WEBSOCKET';
export const TIMER_MYWEBSOCKET_TIMEOUT = 'TIMER_MYWEBSOCKET_TIMEOUT';
export const TIMER_MYWEBSOCKET_HEART = 'TIMER_MYWEBSOCKET_HEART';
export const ISSUE_LIST = 'ISSUE_LIST';
export const TIMER_MYWEBSOCKET_TIMEINTER = 'TIMER_MYWEBSOCKET_TIMEINTER';